import loadable from '@loadable/component';
import { WithLazyHydration } from '../WithLazyHydration';

const ArticleVideoLoadable = loadable(() => import('./ArticleVideo'), {
  resolveComponent: components => components.ArticleVideo
});

export const ArticleVideo = WithLazyHydration(ArticleVideoLoadable, {
  name: 'ArticleVideo'
});
